import React from "react";
import styles from "./MembershipCardBox.module.scss";
import clsx from "clsx";

const MembershipCardBox = ({
  title = "",
  innerTitle,
  innerSubTitle, //innerTitle 아래 보조 문구 (예: "최대 4명")
  children,
  hasMarginBottom,
  isOtherMode, //박스3개,
  fixedBoxHeight, //박스 높이 고정 (예: "320px")
}) => {
  return (
    <div
      className={clsx(styles.container, {
        [styles.otherContainer]: isOtherMode,
      })}
      style={{ marginBottom: hasMarginBottom ? "2rem" : undefined }}
    >
      {title && <h1 className={styles.container__title}>{title}</h1>}
      <div
        className={clsx(styles.container__box, {
          [styles.otherContainer__box]: isOtherMode,
        })}
        style={fixedBoxHeight ? { height: fixedBoxHeight } : undefined}
      >
        {innerTitle && (
          <h2
            className={clsx(styles.otherContainer__innerTitle, {
              [styles.otherContainer__innerTitleTight]: innerSubTitle,
            })}
          >
            {innerTitle}
          </h2>
        )}
        {innerSubTitle && (
          <p className={styles.otherContainer__innerSubTitle}>{innerSubTitle}</p>
        )}
        {children}
      </div>
    </div>
  );
};

export default MembershipCardBox;
